<div matDialogTitle class="dialog-header-row">
  <mat-icon class="dialog-title-icon">group</mat-icon>
  <span class="dialog-title-text" [title]="data.title">{{ data.title }}</span>
  <button mat-icon-button class="dialog-close-btn" (click)="close()" aria-label="Fechar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content-padded">
  <form [formGroup]="movtoForm">

    <ng-container *ngIf="detailsMovto && detailsMovto?.numero_lcto > 0; else noMovto">
      <div class="stat-bar">
        <div class="stat-item">
          <mat-icon class="stat-icon primary-color">receipt_long</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Lctos</span>
            <span class="stat-value">{{ detailsMovto.numero_lcto }}</span>
          </div>
        </div>
        <div class="stat-item">
          <mat-icon class="stat-icon accent-color">event</mat-icon>
          <div class="stat-content">
            <span class="stat-label">1º Lcto</span>
            <span class="stat-value">{{ detailsMovto.data_primeiro_lcto | date: 'dd/MM/yy' }}</span>
          </div>
        </div>
        <div class="stat-item">
          <mat-icon class="stat-icon success-color">event_available</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Último Lcto</span>
            <span class="stat-value">{{ detailsMovto.data_ultimo_lcto | date: 'dd/MM/yy' }}</span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noMovto>
      <div class="no-movto-banner">
        <mat-icon>info_outline</mat-icon>
        <span>Nenhum lançamento registrado para este cadastro</span>
      </div>
    </ng-template>

    <div class="filter-row">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Data Inicial</mat-label>
        <input matInput type="date" [(ngModel)]="dataInicial" (change)="reloadPageMovto()" [ngModelOptions]="{ standalone: true }" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Data Final</mat-label>
        <input matInput type="date" [(ngModel)]="dataFinal" (change)="reloadPageMovto()" [ngModelOptions]="{ standalone: true }" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field hide-on-mobile">
        <mat-label>Ordenar por</mat-label>
        <mat-select [(value)]="selectedOrdem" (selectionChange)="reloadPageMovto()">
          <mat-option value="NENHUM">Controle</mat-option>
          <mat-option value="TRANSACAO">Transação</mat-option>
          <mat-option value="EMISSAO">Emissão</mat-option>
          <mat-option value="ENTRADA">Entrada/Saída</mat-option>
          <mat-option value="VALOR">Total Docto</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field hide-on-mobile">
        <mat-label>Direção</mat-label>
        <mat-select [(value)]="selectedDirect" (selectionChange)="reloadPageMovto()">
          <mat-option value="ASC">Menor para maior</mat-option>
          <mat-option value="DESC">Maior para menor</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" class="filter-btn" (click)="$event.preventDefault(); reloadPageMovto()">
        <mat-icon>refresh</mat-icon>
        <span class="hide-on-mobile">Atualizar</span>
      </button>
    </div>

    <ng-container *ngIf="layoutConf?.isMobile; else desktopMovtoTable">
      <ng-container *ngIf="movtos && movtos.length > 0; else emptyState">
        <div class="movto-card-list">
          <mat-card class="user-card p-0" *ngFor="let row of movtos">
            <mat-card-title>
              <div class="mobile-card-title">
                <div class="mobile-card-title-actions">
                  <span class="movto-natureza-badge"
                        [class.badge-entrada]="row?.serieNatureza !== 'S'"
                        [class.badge-saida]="row?.serieNatureza === 'S'">
                    <mat-icon>{{ row?.serieNatureza === 'S' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                    {{ row?.serieNatureza === 'S' ? 'Saída' : 'Entrada' }}
                  </span>
                  <span class="mobile-card-date">{{ row?.emissao | date: 'dd/MM/yy' }}</span>
                  <button mat-icon-button (click)="$event.preventDefault(); openLcto(row?.controle)" matTooltip="Abrir lançamento">
                    <mat-icon color="primary">open_in_new</mat-icon>
                  </button>
                </div>
                <div class="mobile-card-title-description">
                  {{ (row?.controle ?? 0).toString().padStart(10, '0') }} - {{ (row?.numeroDocto ?? 0).toString().padStart(9, '0') }}
                </div>
              </div>
              <mat-divider></mat-divider>
            </mat-card-title>
            <mat-card-content>
              <div class="user-details">
                <table class="mat-table" style="text-align: left; width: 100%;">
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Status:</td>
                    <td class="mat-cell">{{ row?.statuslcto || '-' }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Entrada/Saída:</td>
                    <td class="mat-cell">{{ row?.dataentradasaida | date:'dd/MM/yy' }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Transação:</td>
                    <td class="mat-cell overflow-cell">{{ (row?.fatTransacaoCodigo ?? '').toString().padStart(5, '0') + '-' + (row?.fatTransacaoDescricao || '') }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Empresa:</td>
                    <td class="mat-cell overflow-cell">{{ (row?.filialId ?? '').toString().padStart(3, '0') + '-' + (row?.filialNomeFantasia || '') }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Total Lcto:</td>
                    <td class="mat-cell"><strong>{{ row?.valortotalDocto | currency:'BRL' }}</strong></td>
                  </tr>
                </table>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>
      <ng-template #emptyState>
        <div class="empty-state">
          <mat-icon>inbox</mat-icon>
          <p>Nenhuma movimentação encontrada para o período</p>
        </div>
      </ng-template>
      <mat-paginator
        #paginator
        [length]="length"
        [showFirstLastButtons]="true"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = setPageSizeOptions($event)">
      </mat-paginator>
    </ng-container>

    <ng-template #desktopMovtoTable>
      <ngx-datatable
        class="material"
        [rows]="movtos"
        [headerHeight]="48"
        [footerHeight]="56"
        [scrollbarH]="true"
        [messages]="{ emptyMessage: 'Nenhuma movimentação encontrada p/ o período' }"
        [limit]="pageSize"
        [rowHeight]="48">
        <ngx-datatable-column name="#" [width]="45">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <strong>{{ rowIndex + 1 }}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Opções" [width]="70">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button color="primary" (click)="$event.preventDefault(); openLcto(row?.controle)">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Status" [width]="90">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.statuslcto }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Controle" [width]="115">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.controle?.toString().padStart(10, '0') }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Emissão" [width]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.emissao | date:'dd/MM/yy' }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Entrada/Saída" [width]="110">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.dataentradasaida | date:'dd/MM/yy' }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Nat" [width]="85">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span [class.saida-text]="row?.serieNatureza === 'S'" [class.entrada-text]="row?.serieNatureza !== 'S'">
              {{ row?.serieNatureza === 'S' ? 'Saída' : 'Entrada' }}
            </span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Docto" [width]="130">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.numeroDocto?.toString().padStart(9, '0') }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Transação" [flexGrow]="2" [minWidth]="180">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ (row?.fatTransacaoCodigo ?? '').toString().padStart(5, '0') + '-' + row?.fatTransacaoDescricao }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Empresa" [flexGrow]="2" [minWidth]="180">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ (row?.filialId ?? '').toString().padStart(3, '0') + '-' + row?.filialNomeFantasia }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Total" [width]="140">
          <ng-template ngx-datatable-header-template>
            <div class="text-right">Total</div>
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.valortotalDocto | currency:'BRL' }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template>
            <mat-paginator
              #paginator
              [length]="length"
              [showFirstLastButtons]="true"
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              (page)="pageEvent = setPageSizeOptions($event)">
            </mat-paginator>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </ng-template>

  </form>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>
    <span class="hide-on-mobile">{{ 'CLOSE' | translate }}</span>
  </button>
</mat-dialog-actions>